module.exports = __webpack_public_path__ + "img/198.3937f072.jpg";